import Select from "react-select";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import { AllCandidateL } from "../../Redux/action/AllCandidateListAction";
// import NewScheduleInterview from "../Vendor/interview/NewScheduleInterview";
import { ToastContainer } from "react-toastify";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Pagination from "../Common/Pagination/Pagination";
import {
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../Redux/action/MasterSkillAction";
import { fetchCountriesData } from "../../Services/GetLocation";
import WindowedSelect from "react-windowed-select";
import { FaEye } from "react-icons/fa6";

const CandidateMenu = ({ candidate, isOpen, onToggle, onClose }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <MoreVertIcon
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      />
      <Menu
        id={`basic-menu-${candidate.candidateId}`}
        anchorEl={isOpen ? candidate.anchorEl : null} // Use the anchorEl specific to each candidate
        open={Boolean(isOpen)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom", // Set to "bottom" to open below the icon
          horizontal: "right", // Set to "right" to align with the right edge of the icon
        }}
        transformOrigin={{
          vertical: "top", // Set to "top" to align with the top edge of the icon
          horizontal: "right", // Set to "right" to align with the right edge of the icon
        }}
        MenuListProps={{
          "aria-labelledby": `basic-button-${candidate.candidateId}`,
        }}
        PaperProps={{
          style: {
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          },
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link to={`/view_candidate/${candidate.candidateId}`}>
            View Profile
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>Request List</MenuItem>
      </Menu>
    </>
  );
};

const BasicMenu = ({ candidate }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="common_btn_outline"
        style={{ borderRadius: "0px", padding: "5px" }}
      >
        Actions
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>
          <Link to={`/view_candidate/${candidate.candidateId}`}>
            View Profile
          </Link>
        </MenuItem>
        {/* <MenuItem onClick={handleClose}>Request List</MenuItem> */}
      </Menu>
    </div>
  );
};

const generateExperienceOptions = (start = 0, labelText = "Select") => {
  const options = [{ value: "", label: labelText }];
  for (let i = start; i <= 31; i++) {
    options.push({ value: i, label: i.toString() });
  }
  return options;
};

const AllCandidateList = () => {
  const [currentPage, setcurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(20);
  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [cities, setcities] = useState([]);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content
  );
  const [pageNumber, setPageNumber] = useState(0);
  const totalPages = useSelector(
    (state) => state?.AllCandidateListData?.result?.totalPages
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const userInfo = useSelector(
    (state) => state?.AllCandidateListData?.result?.content
  );
  const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);
  const [skillVal, setSkillVal] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [citySendApi, setCitySendAPI] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [designationSendapi, setDesignationSendAPI] = useState([]);
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );
  const [selectedMinExp, setSelectedMinExp] = useState({
    value: "",
    label: "Select Min",
  });
  const [selectedMaxExp, setSelectedMaxExp] = useState({
    value: "",
    label: "Select Max",
  });
  const durations = [
    "1 month",
    "1 week",
    "2 days",
    "1 week",
    "1 week",
    "1 month",
    "2 days",
    "2 days",
    "1 month",
    "1 week",
    "2 days",
    "1 week",
    "1 month",
    "1 month",
    "1 month",
  ];
  const location = ["Remote", "Office"];

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleSkillsChange = (selectedOptions) => {
    setSelectedSkills(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setSkillVal(selectedValues);
  };

  const handleCitiesChange = (selectedOptions) => {
    setSelectedCity(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setCitySendAPI(selectedValues);
  };
  const handleDesignationChange = (selectedOptions) => {
    setSelectedDesignation(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setDesignationSendAPI(selectedValues);
  };
  const handleMinChange = (selected) => {
    setSelectedMinExp(selected || { value: "", label: "Select Min" });

    // Reset max if it’s less than the new min
    if (
      selectedMaxExp.value !== "" &&
      selected &&
      parseInt(selectedMaxExp.value) < parseInt(selected.value)
    ) {
      setSelectedMaxExp({ value: "", label: "Select Max" });
    }
  };

  const handleMaxChange = (selected) => {
    setSelectedMaxExp(selected || { value: "", label: "Select Max" });
  };

  const minOptions = generateExperienceOptions(0, "Select Min");
  const maxOptions = generateExperienceOptions(
    selectedMinExp.value !== "" ? parseInt(selectedMinExp.value) : 0,
    "Select Max"
  );
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = userResult?.vendorid;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const min = selectedMinExp.value;
    const max = selectedMaxExp.value;
    const encodedData = skillVal?.map((item) => encodeURIComponent(item));

    const content = {
      vendorId,
      search,
      pageNumber,
      citySendApi,
      encodedData,
      designationSendapi,
      min,
      max,
    };
    dispatch(AllCandidateL(content));
  }, [
    search,
    pageNumber,
    skillVal,
    citySendApi,
    designationSendapi,
    selectedMaxExp,
    selectedMinExp,
  ]);

  useEffect(() => {
    setPageNumber(0);
  }, [
    search,
    skillVal,
    citySendApi,
    designationSendapi,
    selectedMaxExp,
    selectedMinExp,
  ]);

  useEffect(() => {
    dispatch(fetchSkillDetails());
    fetchCountriesData().then((res) => {
      console.log("countries in all candidate ", res?.data?.data);
      setcities(res?.data?.data);
    });
    dispatch(fetchDesignationDetails());
  }, []);

  // const userInfo = useSelector((state) => state.AllCandidateListData.result);

  const handleClick = (e) => {
    setcurrentPage(Number(e.target.id));
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const newData = userInfo;
  const renderPageNumbers = pages.map((number) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <li
          key={number}
          id={number}
          onClick={handleClick}
          className={currentPage === number ? "active" : null}
        >
          {number}
        </li>
      );
    } else {
      return null;
    }
  });

  const handleNextbtn = () => {
    setcurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageNumberLimit) {
      setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePrevbtn = () => {
    setcurrentPage(currentPage - 1);

    if ((currentPage - 1) % pageNumberLimit === 0) {
      setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
  }

  let pageDecrementBtn = null;
  if (minPageNumberLimit >= 1) {
    pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
  }

  const handleCandidateId = (e, candidate) => {
    if (e.target.checked) {
      setSelectedCandidates((current) => [...current, candidate]);
    } else {
      setSelectedCandidates((current) =>
        current.filter((c) => c !== candidate)
      );
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = anchorEl;

  const handleDropdownToggle = (candidateId) => {
    if (selectedCandidateId === candidateId) {
      setSelectedCandidateId(null);
    } else {
      setSelectedCandidateId(candidateId);
    }
  };

  const handleClose = () => {
    setSelectedCandidateId(null);
  };

  const options = AllSkillList?.map((item) => ({
    value: item?.skillName,
    label: item?.skillName,
  }));
  const citiesOption = cities?.map((item) => ({
    value: item,
    label: item,
  }));
  const designationOptions = AllDesignationList?.map((item) => ({
    value: item?.designation,
    label: item?.designation,
  }));

  return (
    <div>
      <ToastContainer />
      <div className="custom_container">
        <div style={{ background: "#cefff5" }}></div>
        <div>
          <div className="searchCanContainer">
            <div
              className="common_wrapper common_shadow mt-2 p-4"
              style={{ marginBottom: "15px" }}
            >
              <div className="row g-2" style={{ margin: "auto" }}>
                <div className="col-12 col-sm-6 col-md-4 col-lg-6">
                  <label className="mb-1">Search By Candidate Id</label>
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search by candidate id"
                    name="search"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPageNumber(0);
                    }}
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-6">
                  <label className="mb-1">Min Exp (year)</label>
                  <Select
                    options={minOptions}
                    value={selectedMinExp}
                    onChange={handleMinChange}
                    placeholder="Select Min"
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-6">
                  <label className="mb-1">Max Exp (year)</label>
                  <Select
                    options={maxOptions}
                    value={selectedMaxExp}
                    onChange={handleMaxChange}
                    placeholder="Select Max"
                  />
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                  <label className="mb-1">Designation</label>
                  <Select
                    options={designationOptions}
                    isMulti
                    onChange={handleDesignationChange}
                    placeholder="Select Designation"
                    value={selectedDesignation}
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                  <label className="mb-1">City</label>
                  <WindowedSelect
                    options={citiesOption}
                    isMulti
                    onChange={handleCitiesChange}
                    value={selectedCity}
                    placeholder="Select Cities"
                  />
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                  <label className="mb-1">Skill</label>
                  <Select
                    options={options}
                    isMulti
                    placeholder="Select Skills"
                    onChange={handleSkillsChange}
                    value={selectedSkills}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="common_wrapper mt-3">
            <div className="card-header common_table_header">
              All Candidates
            </div>
            <div
              style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
            >
              <table
                className="table-data"
                style={{
                  fontSize: "12px",
                  minWidth: "700px",
                  borderCollapse: "collapse",
                  width: "100%",
                }}
              >
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Candidate Id
                    </th>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Designation
                    </th>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Experience
                    </th>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Location
                    </th>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Preferred Location
                    </th>
                    <th
                      scope="col"
                      className="fw_500"
                      style={{ textAlign: "left" }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems &&
                    currentItems.map((item, i) => (
                      <tr key={i}>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start", // 🔹 left aligned
                            gap: "8px",
                            textAlign: "left",
                          }}
                        >
                          <div
                            style={{
                              width: "34px",
                              height: "34px",
                              borderRadius: "50%",
                              backgroundColor: "#286a94",
                              color: "#fff",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight: "bold",
                              fontSize: "14px",
                              textTransform: "uppercase",
                            }}
                          >
                            {`${item.firstName?.[0] || ""}${
                              item.lastName?.[0] || ""
                            }`}
                          </div>
                          <span>{item.candidateEmpId}</span>
                        </td>

                        <td style={{ textAlign: "left" }}>
                          {item.currentDesignation || "N/A"}
                        </td>

                        <td style={{ textAlign: "left" }}>
                          {(() => {
                            const years = parseInt(item?.keyExperience) || 0;
                            const months =
                              parseInt(item?.keyExperienceInMonth) || 0;
                            if (years === 0 && months === 0) return "Fresher";
                            const yearsText =
                              years > 0
                                ? `${years} Year${years > 1 ? "s" : ""}`
                                : "";
                            const monthsText =
                              months > 0
                                ? `${months} Month${months > 1 ? "s" : ""}`
                                : "";
                            return yearsText && monthsText
                              ? `${yearsText} - ${monthsText}`
                              : yearsText || monthsText;
                          })()}
                        </td>

                        <td style={{ textAlign: "left" }}>
                          {item?.city + ", " + item?.country}
                        </td>

                        <td style={{ textAlign: "left" }}>REMOTE</td>

                        <td style={{ textAlign: "left" }}>
                          <Link to={`/view_candidate/${item.candidateId}`}>
                            <FaEye size={18} />
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {userInfo?.length > 0 ? (
          <Pagination
            totalPages={totalPages}
            currentPage={pageNumber}
            onPageChange={handlePageChange}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AllCandidateList;
